import { useMemo } from 'react';
import { useLocation } from 'react-router';

function useMainHooks() {
  let isAIGenerated = false;
  let isNewDiagram = false;
  let isSavedDiagram = false; // no backend records created yet

  let diagramId: string | null = null;
  let recordId: string | null = null;

  const { search } = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(search), [search]);

  if (queryParams.has('term') && queryParams.has('hazard') && queryParams.has('mue')) {
    isAIGenerated = true;
    isNewDiagram = false;
    isSavedDiagram = false;
  } else if (queryParams.has('import')) {
    isAIGenerated = true;
    isNewDiagram = false;
    isSavedDiagram = false;
  } else if (queryParams.has('records') || queryParams.has('recordId')) {
    isAIGenerated = false;
    isNewDiagram = false;
    isSavedDiagram = false;
    recordId = queryParams.get('records') || queryParams.get('recordId');
  } else if (queryParams.has('diagramId')) {
    isAIGenerated = false;
    isNewDiagram = false;
    isSavedDiagram = true;
    diagramId = queryParams.get('diagramId');
  } else {
    isAIGenerated = false;
    isNewDiagram = true;
    isSavedDiagram = false;
  }

  return {
    isAIGenerated,
    isNewDiagram,
    isSavedDiagram,
    diagramId,
    recordId,
  };
}

export default useMainHooks;
